import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { Outlet } from "react-router-dom";

const LayoutDefault = () => (
  <React.Fragment>
    <Header className="" />
    <main className="site-content">
      {/* {children} */}
      <Outlet />
    </main>
    <Footer />
  </React.Fragment>
);

export default LayoutDefault;  